import { Component, Vue } from 'vue-property-decorator'
import { getProgressList, getSubmitterNote, backOrder, deleteOrder, queryStudent } from '@/api'
import HighFilter from '@/components/highFilter/index.vue'

@Component({
  name: 'ApproveProgressPage',
  filters: {
    statusFilter: (data: any) => {
      if (data === 0) return '未审批'
      else if (data === 1) return '通过'
      else if (data === 2) return '已驳回'
      return data
    }
  },
  components: { HighFilter }
})
export default class ApproveProgressPage extends Vue {
  private dataType = 1 // 1 - 审批进度 2 - 回收箱
  private totalPage = 100;
  private currentPage = 1;
  private ideaDialogVisible = false; // 审批意见弹窗
  private reCreateDialogVisible = false; // 续报弹窗
  private reCreateStudentChoose = null; // 选中的续报学生
  private idea = '' // 审批意见
  private studentList: any = []; // 续报学生的列表
  private tableData = []
  private tableloading: any = false
  private subjectName: any = null; // 续报学生的列表
  private time: any = null
  private showHighFilter: any = false
  private filterData: any = {};
  private filterResult: any = null

  created () {
    if (sessionStorage.getItem('page')) {
      this.currentPage = Number(sessionStorage.getItem('page'))
    }
    this.initProgressPageData()
  }

  private async initProgressPageData () {
    this.tableloading = true
    window.sessionStorage.setItem('page', String(this.currentPage))
    const param: any = { page: this.currentPage, limit: 20, isSketch: this.dataType === 2, subjectName: this.subjectName }
    if (this.filterResult) {
      param.search = this.filterResult
    }
    const result: any = await getProgressList(param)
    const { allPage, currentPage, workOrderList } = result
    this.currentPage = currentPage
    this.totalPage = allPage
    this.tableData = workOrderList
    this.filterData = result.search
    this.tableloading = false
  }

  private onTypeChange (type: any) {
    if (this.dataType === type) { return }
    this.dataType = type
    // 切换以后 需要把当前页标记归位
    this.subjectName = null
    this.seachSubjectName()
  }

  private seachSubjectName () {
    this.currentPage = 1
    this.tableData = []
    this.initProgressPageData()
  }

  private async onFilterResult (data: any) {
    this.filterResult = data
    this.currentPage = 1
    await this.initProgressPageData()
    this.showHighFilter = false
  }

  // 续报弹窗打开
  private async onXBClick () {
    this.reCreateDialogVisible = true
  }

  /**
   * [description] 新签学员被点击
   */
  private onCreateStudentClick () {
    this.$router.push({ path: '/student/create', query: { action: 'create' } })
  }

  /**
   * [description] 续报按钮回调函数
   */
  private onReCreateStudentClick () {
    this.reCreateDialogVisible = false
    this.$router.push({ path: '/student/continue', query: { id: this.reCreateStudentChoose } })
  }

  /**
   * [description] 分页更改
   */
  private onPageChange () {
    this.initProgressPageData()
  }

  private async remoteMethod (query: any) {
    clearTimeout(this.time)
    this.time = setTimeout(async () => {
      if (query !== '') {
        const result: any = await queryStudent({ name: query, isContinue: true })
        this.studentList = result
      } else {
        this.studentList = []
      }
    }, 300)
  }

  private onstudentChanged (id: string) {
    const data = this.studentList.filter((item: any) => { return id === item.id })
    if (data.length > 0) {
      this.studentList.project = JSON.parse(JSON.stringify(data[0]))
      this.studentList.courseId = id
    }
  }

  /**
   * [description] 审批意见
   */
  private async onApproveClick (item: any) {
    const result: any = await getSubmitterNote({ id: item.id })
    this.ideaDialogVisible = true
    this.idea = result
  }

  /**
   * [description] 收回审批
   */
  private async onBackClick (item: any) {
    await backOrder({ workOrderId: item.id })
    this.$message({ message: '操作成功', type: 'success' })
    await this.initProgressPageData()
  }

  /**
   * [description] 删除点击
   */
  private onDeleteClick (item: any) {
    this.$confirm('确定要删除么？', { type: 'warning' }).then(async () => {
      await deleteOrder({ id: item.id })
      this.$message({ message: '操作成功', type: 'success' })
      await this.initProgressPageData()
    })
  }

  /**
   * [description] 重新编辑
   */
  private onReEditClick (item: any) {
    if (item.type === 7 || item.type === 4 || item.type === 3) {
      this.$router.push({ path: '/approve/create', query: { id: item.id, type: item.type, action: 'edit' } }) // type是7 代表退项目
    } else if (item.type === 2) {
      this.$router.push({ path: '/student/continue', query: { orderId: item.id, type: item.type, action: 'edit' } }) // type-2 是 续报重新编辑
    } else {
      this.$router.push({ path: '/student/create', query: { id: item.id, action: 'edit', type: item.type } })
    }
  }

  // 判断是否显示收回审批按钮
  private checkRebackBtnShow (data: any) {
    // 审批类型 1，新签；2，续报；3，换项目；4，换老师；5，异常；6；结课 7退项目
    // 审批状态 0-未审批 1-通过 2-未通过
    if (this.dataType === 2) return false
    return (data.status === 0 || (data.status === 2 && (
      data.type === 1 ||
      data.type === 2 ||
      data.type === 3 ||
      data.type === 4 ||
      data.type === 7)))
  }

  // table某一行被点击
  private tableRowClick (row: any) {
    const { type, status, id } = row
    if (status !== 1) return
    if (type === 1 || type === 2 || type === 3 || type === 4 || type === 7) {
      this.$router.push({ path: '/approve/sign', query: { id: row.id, type: row.type, action: 'look' } })
    }
  }

  // 退项目
  private onQuitProjectClick (row: any) {
    const { type, status, id } = row
    this.$router.push({ path: '/approve/create', query: { id, type: type, action: 'quit' } }) // type是7 代表退项目
  }

  // 查看工单
  private onLookClick (item: any) {
    if (item.type === 1 || item.type === 2 || item.type === 3 || item.type === 4 || item.type === 7) {
      this.$router.push({ path: '/approve/sign', query: { id: item.id, type: item.type, action: 'look' } })
    } else if (item.type === 6) {
      this.$router.push({ path: '/approve/classover', query: { id: item.id, classId: item.endClassId } })
    } else if (item.type === 5) { // 5是异常
      this.$router.push({ path: '/approve/anomaly', query: { id: item.id } })
    }
  }

  // 重新报名
  private onResign (item: any) {
    this.$router.push({ path: '/student/continue', query: { id: item.studentId } })
  }
}
